<app-config-top-nav></app-config-top-nav>

<div class="pay-groups-container">
  <!-- Loading -->
  <div *ngIf="isLoading" class="spinner-container">
    <div class="spinner"></div>
  </div>

  <!-- Error -->
  <div *ngIf="errorMessage" class="error-message">{{ errorMessage }}</div>

  <!-- Header -->
  <div class="header" *ngIf="!isLoading">
    <h2>Pay Groups</h2>
    <div class="header-actions">
      <button class="btn btn-primary" (click)="openCreateModal()">+ New Pay Group</button>
    </div>
  </div>

  <!-- Sticky Pagination -->
  <div class="pagination sticky" *ngIf="!isLoading">
    <div class="page-controls">
      <button (click)="changePage(currentPage - 1)" [disabled]="currentPage === 1">Prev</button>
      <span>Page {{ currentPage }} of {{ totalPages }}</span>
      <button (click)="changePage(currentPage + 1)" [disabled]="currentPage === totalPages">
        Next
      </button>
    </div>

    <div class="page-size">
      <label for="pageSize">Page Size:</label>
      <select id="pageSize" [(ngModel)]="pageSize" (change)="changePageSize(pageSize)">
        <option *ngFor="let size of pageSizes" [value]="size">{{ size }}</option>
      </select>
    </div>
  </div>

  <!-- Filters -->
  <div class="filters-container" *ngIf="!isLoading">
    <div class="filters-row">
      <label class="filter-field search-field">
        <app-search-bar
          [value]="filters.searchTerm"
          [debounceMs]="600"
          placeholder="Search pay group name"
          (searchChange)="onSearchTermChange($event)">
        </app-search-bar>
      </label>
    </div>
  </div>

  <!-- Pay Groups List -->
  <div class="pay-groups-list">
    <div *ngFor="let pg of payGroups$ | async" class="pay-group-row">
      <div class="pay-group-info">
        <div class="pay-group-name">{{ pg.name }}</div>
        <div class="pay-group-description">{{ pg.description || '' }}</div>

        <div class="pay-group-overtime">
          <span>Overtime Eligible: {{ pg.isOvertimeEligible ? 'Yes' : 'No' }}</span>
          <span> | Base Pay Threshold Hours: {{ pg.overtimeThresholdHours }}</span>
        </div>
      </div>

      <div class="pay-group-actions">
        <button class="btn edit" (click)="openEditModal(pg)">Edit</button>
        <button class="btn delete" (click)="confirmDelete(pg)">Delete</button>
      </div>
    </div>
  </div>

  <!-- Create/Edit Modal -->
  <div *ngIf="modalOpen" class="modal-backdrop">
    <div class="modal pay-group-modal" (click)="$event.stopPropagation()">
      <h2>{{ isEditMode ? 'Edit Pay Group' : 'New Pay Group' }}</h2>

      <form #payGroupForm="ngForm" (ngSubmit)="submitPayGroup(payGroupForm)">
        <label for="payGroupName">Name</label>
        <input
          id="payGroupName"
          type="text"
          [(ngModel)]="formModel.name"
          name="name"
          required />

        <label for="payGroupDescription">Description</label>
        <textarea
          id="payGroupDescription"
          [(ngModel)]="formModel.description"
          name="description">
        </textarea>

        <label for="isOvertimeEligible">Overtime Eligible</label>
        <select
          id="isOvertimeEligible"
          [(ngModel)]="formModel.isOvertimeEligible"
          name="isOvertimeEligible">
          <option [ngValue]="true">Yes</option>
          <option [ngValue]="false">No</option>
        </select>

        <label for="overtimeThresholdHours">
          Base Pay Threshold Hours
          <span class="tooltip-container">
            <img src="/info-icon.webp" alt="Info" class="tooltip-icon" />
            <span class="tooltip-text">
              The base hour threshold used for this pay group.
            </span>
          </span>
        </label>

        <input
          id="overtimeThresholdHours"
          type="number"
          [(ngModel)]="formModel.overtimeThresholdHours"
          name="overtimeThresholdHours" />

        <div class="modal-buttons">
          <button type="button" class="btn btn-secondary" (click)="closeModal()">Cancel</button>
          <button type="submit" class="btn btn-primary">
            {{ isEditMode ? 'Update' : 'Create' }}
          </button>
        </div>
      </form>
    </div>
  </div>

  <!-- Delete Modal -->
  <div *ngIf="deleteConfirmOpen" class="modal-backdrop">
    <div class="modal confirm-modal" (click)="$event.stopPropagation()">
      <h2>Delete Pay Group</h2>
      <p class="modal-text">
        Are you sure you want to delete <strong>{{ payGroupToDelete?.name }}</strong>?
      </p>

      <div class="modal-buttons confirm-buttons">
        <button type="button" class="btn btn-secondary" (click)="cancelDelete()">Cancel</button>
        <button type="button" class="btn btn-danger" (click)="deletePayGroup()">Delete</button>
      </div>
    </div>
  </div>

  <!-- Toast -->
  <div *ngIf="toastVisible" class="toast" [ngClass]="toastType">
    <img class="icon" alt="icon" />
    <span>{{ toastMessage }}</span>
  </div>
</div>